export default {
  notificationHandlers: state => {
    return state.notificationHandlers;
  },
  notificationChannels: state => {
    return state.notificationChannels;
  }
};